/***************************************************************************/
"use client";
/***************************************************************************/

const ScreenFooter: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({
  children,
  ...props
}) => {
  return <div {...props}>{children}</div>;
};

export { ScreenFooter };
